S.init = {
    /** @type {MediaQueryList[]} */
    resizeTransitionQueries: [],

    /** @type {Function} */
    resizeTransitionListener: null,

    init()
    {
        this.initTabFocus();
        this.initResizeTransition();
    },

    destroy()
    {
        this.destroyTabFocus();
        this.destroyResizeTransition();
    },

    /**
     * Setup accessibility handling for tab navigation
     */
    initTabFocus()
    {
        jQuery(document).on('keydown.keyboardFocus', (event) =>
        {
            // we only care about the tab key
            if (event.which !== 9)
            {
                return;
            }

            this.$module.addClass('is-keyboard-focus');

            jQuery(document).one('click.keyboardFocus touchstart.keyboardFocus', () =>
            {
                this.$module.removeClass('is-keyboard-focus');
            });
        });
    },

    destroyTabFocus()
    {
        jQuery(document).off('keydown.keyboardFocus click.keyboardFocus touchstart.keyboardFocus');

        this.$module.removeClass('is-keyboard-focus');
    },

    /**
     * Disable transitions globally for a tick on media query breakpoints
     *
     * @see /assets/sass/_project/globals.scss .no-transition
     */
    initResizeTransition()
    {
        this.$module.removeClass('no-transition');

        // no breakpoints available
        if (typeof S.breakpoints !== 'object')
        {
            return;
        }

        // no mq available
        if (typeof S.mq !== 'function')
        {
            return;
        }

        // keep a reference to our listener
        this.resizeTransitionListener = this.handleResizeTransition.bind(this);

        // walk through all known breakpoints
        for (const breakpoint in S.breakpoints)
        {
            // filter possible inherited members
            if (!Object.prototype.hasOwnProperty.call(S.breakpoints, breakpoint))
            {
                continue;
            }

            // skip print
            if (breakpoint === 'print')
            {
                continue;
            }

            const mq = S.mq(breakpoint);

            mq.addListener(this.resizeTransitionListener);

            this.resizeTransitionQueries.push(mq);
        }
    },

    destroyResizeTransition()
    {
        for (const mq of this.resizeTransitionQueries)
        {
            mq.removeListener(this.resizeTransitionListener);
        }
    },

    handleResizeTransition()
    {
        // disable transition for a tick
        this.$module.addClass('no-transition');

        // and enable it again
        setTimeout(() =>
        {
            this.$module.removeClass('no-transition');
        }, 0);
    },

    /**
     * Injects `var(--scrollbar-width)` and `var(--scrollbar-half-width)` variables into local stylesheet
     */
    injectScrollbarWidth()
    {
        try
        {
            for (const styleSheet of document.styleSheets)
            {
                let index = 0;

                for (const cssRule of styleSheet.cssRules)
                {
                    if ((cssRule instanceof CSSStyleRule) && cssRule.selectorText === ':root' && cssRule.cssText.match('--scrollbar-half-width'))
                    {
                        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

                        styleSheet.deleteRule(index);

                        styleSheet.insertRule(`:root{--scrollbar-width:${scrollbarWidth}px;--scrollbar-half-width:${0.5 * scrollbarWidth}px}`, index);

                        break;
                    }

                    index++;
                }
            }
        }
        catch (e)
        {
        }
    },
};

// remove the "no-js" class as soon as possible, don't wait for the ready event or module initialization
jQuery('body').removeClass('no-js');

// set the --scrollbar-width CSS variables, don't wait for the ready event or module initialization
S.init.injectScrollbarWidth();
